import { Debug } from "@/util/debug";
import { useEffect, useState } from "react";

export function useFlexWrapDetect(containerRef: React.RefObject<HTMLElement | null>) {
  const [isWrapped, setIsWrapped] = useState(false);

  useEffect(() => {
    const checkWrap = () => {
      const container = containerRef.current;
      if (!container) return;

      const children = container.children;
      if (children.length < 2) return;

      const first = children[0] as HTMLElement;
      const second = children[1] as HTMLElement;

      // 두번째 요소의 y(위치)가 첫번째보다 더 아래면 wrap된 것
      // Debug("checkWrap", second, first, second.offsetTop, first.offsetTop);
      const check = Math.abs(second.offsetTop - first.offsetTop) > 20;
      setIsWrapped(check);
    };

    checkWrap(); // 초기 체크

    const observer = new ResizeObserver(checkWrap);

    if (containerRef && containerRef.current) {
      observer.observe(containerRef.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [containerRef]);

  return isWrapped;
}
